export default "__VITE_ASSET__D8eTHl_S__"